import { getCookie } from 'utils/cookies';

function getNewOlSToken() {
  if (navigator.cookieEnabled) return getCookie('new_ols_access_token');
  return null;
}

function getToken() {
  if (navigator.cookieEnabled) return getCookie('access_token');
  return null;
}

function getRememberMeToken() {
  if (navigator.cookieEnabled) return getCookie('rememberMe_access_token');
  return null;
}

function getAdminToken() {
  if (navigator.cookieEnabled) return getCookie('admin_token');
  return null;
}

function decodeToken(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(c => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

  return JSON.parse(jsonPayload);
}

function setRememberMeToken(token) {
  var max_age = 30 * 24 * 60 * 60;
  if (navigator.cookieEnabled)
    //updated max-age
    document.cookie = `rememberMe_access_token=${token}; path=/; ${`max-age=${max_age}`}`;
}

function setToken(token, sfId) {
  // const { favoriteLocation } = decodeToken(token);
  localStorage.setItem('sfId', sfId);
  if (navigator.cookieEnabled)
    //updated max-age
    document.cookie = `access_token=${token}; path=/; max-age=${process.env.REACT_APP_COOKIE_TIME_TO_LIVE}`;
}

function setAdminToken(token) {
  const max_age = 30 * 24 * 60 * 60;
  if (navigator.cookieEnabled)
    document.cookie = `admin_token=${token}; path=/; max-age=${max_age}`;
}

function removeToken() {
  localStorage.removeItem('sfId');
  localStorage.removeItem('tncPopupClosed');
  if (navigator.cookieEnabled) document.cookie = `access_token=; path=/; max-age=0 `;
}

function removeRememberMeToken() {
  if (navigator.cookieEnabled)
    document.cookie = `rememberMe_access_token=; path=/; max-age=0 `;
}

function removeAdminToken() {
  if (navigator.cookieEnabled) document.cookie = `admin_token=; path=/; max-age=0 `;
}

async function clearCache() {
  return Promise.all([
    caches.delete('working-cache'),
    caches.delete('one-day-cache'),
    caches.delete('schedule-cache'),
    caches.delete('trainers-cache'),
    caches.delete('sessions-cache'),
    // caches.delete('b-cache'),
  ]);
}

export default {
  setToken,
  removeToken,
  getToken,
  decodeToken,
  clearCache,
  getNewOlSToken,
  setRememberMeToken,
  removeRememberMeToken,
  getRememberMeToken,
  setAdminToken,
  removeAdminToken,
  getAdminToken,
};
